import { render, staticRenderFns } from "./FilterDropdown.vue?vue&type=template&id=b5529058&scoped=true&"
import script from "./FilterDropdown.vue?vue&type=script&lang=js&"
export * from "./FilterDropdown.vue?vue&type=script&lang=js&"
import style0 from "./FilterDropdown.vue?vue&type=style&index=0&id=b5529058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5529058",
  null
  
)

export default component.exports